var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figcaption',{staticClass:"image-hover-caption md_absolute md_-bottom-15 left-0 md_bg-white text-black w-full pt-5 md_py-15 pr-15 md_opacity-0 group-hover_opacity-100 transition duration-150 text-10 xl_text-12"},[_c('image-asset-caption',{attrs:{"image":_vm.image,"caption":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }